export const demos = [
  { 
    id: 'pathfinding',
    to: "/demos/pathFinding", 
    title: "Path Finding Demo", 
    date: "Summer 2023" 
  },
  { 
    id: 'game-of-life',
    to: "/demos/gameOfLife", 
    title: "Conway's Game of Life", 
    date: "Summer 2023" 
  },
  { 
    id: 'gravity',
    to: "/demos/gravitySimulator", 
    title: "Gravity Sandbox", 
    date: "Summer 2023" 
  },
  { 
    id: 'boids',
    to: "/", 
    title: "Boids (Homepage)", 
    date: "Summer 2023" 
  },
  { 
    id: 'raytracer',
    to: "/demos/RayTracer", 
    title: "Ray Tracer (WebGPU)", 
    date: "Summer 2025" 
  },
  { 
    id: 'fluid',
    to: null, 
    title: "Fluid Simulation", 
    date: "Coming Soon" 
  },
];